/*=========================================================================================
  File Name: moduleChatMutations.js
  Description: Chat Module Mutations

==========================================================================================*/

import Vue from 'vue'

export default {
  UPDATE_ABOUT_CHAT(state, obj) {
    obj.rootState.AppActiveUser.about = obj.value
  },
  UPDATE_STATUS_CHAT(state, obj) {
    obj.rootState.AppActiveUser.status = obj.value
  },

  // API AFTER
  SEND_CHAT_MESSAGE(state, payload) {
    payload.data.isSent = true
    payload.data.isSeen = true

    if (payload.chatData) {
      // If there's already chat. Push msg to existing chat
      state.chats[Object.keys(state.chats).find(key => key === payload.to)].push(payload.data)
    } else {
      // Create New chat and add msg
      Vue.set(state.chats, [payload.to], [payload.data])
    }
  },
  UPDATE_CONTACTS(state, contacts) {
    state.whitelistContacts = contacts.whitelist
    state.blacklistContacts = contacts.blacklist
  },
  UPDATE_CONTACTS_STATUS(state, data) {
    data.forEach(s => {
      const user = state.whitelistContacts.find(u => u.userId === s.userId)
      const userIndex = state.whitelistContacts.findIndex(u => u.userId === s.userId)
      if (user) {
        user.status = s.status
        Vue.set(state.whitelistContacts, [userIndex], user)
      }
    })
  },
  UPDATE_CHATS(state, { id, chats }) {
    let parsed_chats = {}
    chats.forEach(chat => {
      const contact = chat.to === id ? chat.from : chat.to
      chat.isSent = chat.from === id
      chat.isSeen = chat.state === 'visited'
      if (!(contact in parsed_chats)) parsed_chats[contact] = []
      parsed_chats[contact].push(chat)
    })
    state.chats = parsed_chats
  },
  RECEIVE_CHAT_MESSAGE(state, payload) {
    payload.data.isSent = false
    payload.data.isSeen = false

    if (payload.chatData) {
      // If there's already chat. Push msg to existing chat
      state.chats[Object.keys(state.chats).find(key => key === payload.data.from)].push(payload.data)
    } else {
      // Create New chat and add msg
      Vue.set(state.chats, [payload.data.from], [payload.data])
    }
  },
  SET_ACTIVE_CHAT_USER(state, value) {
    state.activeChatUser = value
  },
  MARK_SEEN_ALL_MESSAGES(state, payload) {
    payload.chatData.forEach(msg => {
      msg.state = 'visited'
      msg.isSeen = true
    })
  },
  SET_ON_CALL_USER(state, value) {
    state.onCallUser = value
  },
  SET_IS_CALLER(state, value) {
    state.isCaller = value
  },
  UPDATE_VIDEO_CHAT_DATA(state, payload) {
    state.videoChatData = payload
  }
}
